import './ReferralHeader.scss'

import React from 'react';
import ReferralContact from './ReferralContact'
import {
  ASSIGNMENT_AGENT_STATUS,
  ASSIGNMENT_AGENT_STATUS_LISTING,
  ASSIGNMENT_AGENT_STATUS_LEASE,
  BUYER_TYPE,
  AGENT_STATUS_CLOSED,
  CLOSING_CHECKLIST,
  CLOSING_STMT_INCOMPLETE_REASON,
} from 'common/constants'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { labelFor } from 'common/util/helper'
import { push } from 'react-router-redux'
import {
  selectReferralIsTransition,
  selectReferralTags,
} from 'manager/selectors/referral_selectors'
import { VIPBadge } from 'manager/views/components/Referral/ReferralBadge'
import marketVIPIcon from '../../../../images/market-vip.svg'

const CloseChecklist = ({ closingStatementReceived, incompleteClosingStatementReason, paymentReceived, isPartialPayment }) => {
  let docStatus = 'none'
  let docIcon = 'times'
  let paymentStatus = 'none'
  let paymentIcon = 'times'
  if (isPartialPayment) {
    paymentStatus = 'incomplete'
    paymentIcon = 'exclamation'
  } else if (paymentReceived) {
    paymentStatus = 'received'
    paymentIcon = 'check'
  }

  if (incompleteClosingStatementReason) {
    docStatus = 'missing'
    docIcon = 'exclamation'
  } else if (closingStatementReceived) {
    docStatus = 'received'
    docIcon = 'check'
  }

  return <div className="ReferralCloseChecklist">
    <div className="ReferralCloseChecklist__item">
      <div className={`ReferralCloseChecklist__icon-${docStatus}`}><i className={`fa fa-${docIcon}-circle`}/></div>
      <div className="ReferralCloseChecklist__text">Closing Statements</div>
      <div className={`ReferralCloseChecklist__status-${docStatus}`}>{incompleteClosingStatementReason ? labelFor(CLOSING_STMT_INCOMPLETE_REASON, incompleteClosingStatementReason) : labelFor(CLOSING_CHECKLIST, docStatus)}</div>
    </div>
    <div className="ReferralCloseChecklist__item">
      <div className={`ReferralCloseChecklist__icon-${paymentStatus}`}><i className={`fa fa-${paymentIcon}-circle`}/></div>
      <div className="ReferralCloseChecklist__text">Referral Fees</div>
      <div className={`ReferralCloseChecklist__status-${paymentStatus}`}>{labelFor(CLOSING_CHECKLIST, paymentStatus)}</div>
    </div>
  </div>
}

const ReferralHeaderComp = (props) => {

  const {
    canUseInbox,
    canUseVoip,
    dispatch,
    isTransition,
    params,
    referral = {},
    route,
  } = props

  const {
    closing_stmt_received,
    closing_stmt_incomplete_reason,
    payment_received,
    full_payment_received,
    overdue_balance_remaining_currency,
    overdue_paid_currency,
    agent_status,
    is_lease,
    transaction_type,
    client_category,
    agent_hold_until,
    name,
    phone,
    email,
    is_mvip_assignment,
  } = referral

  const handleClick = () => {
    dispatch(push({
      pathname:`/referral/${params.hash}`,
      query:{contact: true}
    }))
  }

  let isNewTransaction = route.path === 'add'
  const showCloseChecklist = !isNewTransaction && agent_status === AGENT_STATUS_CLOSED && !is_mvip_assignment

  let agentStatus
  if (is_lease) {
    agentStatus = labelFor(ASSIGNMENT_AGENT_STATUS_LEASE, agent_status)
  } else {
    agentStatus = transaction_type === 'list' ? labelFor(ASSIGNMENT_AGENT_STATUS_LISTING, agent_status) : labelFor(ASSIGNMENT_AGENT_STATUS, agent_status)
  }
  agentStatus = isNewTransaction ? "New" : agentStatus

  const isEmailValid = email ? !email.match('Declined email') : false

  return (
    <div className="ReferralHeader">
      <div className="ReferralHeader__left">
        <div className="ReferralHeader__name" onClick={handleClick}>
          {name && name.match('Declined last name') ? name.split(' ')[0] : name}
          {isTransition && <VIPBadge icon={marketVIPIcon} />}
          <i className="fa fa-pencil ReferralHeader__pencil"/>
        </div>
        <div className="ReferralHeader__phone">{phone}</div>
        { isEmailValid ? <div className="ReferralHeader__email">{email}</div> : <div className="ReferralHeader__no_email">No email provided</div> }
        <div className={"ReferralHeader__type ReferralHeader__type-" + client_category}/><span className="ReferralHeader__type-value">{ labelFor(BUYER_TYPE, client_category) }</span>
      </div>
      <div className="ReferralHeader__status">
        <div className="ReferralHeader__status__badges_container">
          <span className="ReferralHeader__status__label">Current Status</span>
          <div className="ReferralStatusBadges">
            <span className="ReferralStatusBadges__badge">
              { agentStatus }
            </span>
            {agent_hold_until && <span className="ReferralStatusBadges__badge ReferralStatusBadges__badge--holding">Long Term Hold</span>}
          </div>
        </div>
        { showCloseChecklist && (
          <CloseChecklist
            closingStatementReceived={!!closing_stmt_received}
            incompleteClosingStatementReason={closing_stmt_incomplete_reason}
            paymentReceived={!!payment_received}
            isPartialPayment={!full_payment_received && !!overdue_balance_remaining_currency && !!overdue_paid_currency}
          />
        ) }
      </div>
      <div className="ReferralHeader__right">
        <ReferralContact canUseInbox={canUseInbox} canUseVoip={canUseVoip} {...props}/>
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  isTransition: selectReferralIsTransition,
  transactionTags: selectReferralTags,
})

const actions = {}

const withRedux = connect(selector, actions)

export const ReferralHeader = withRedux(ReferralHeaderComp)
